export default {"src":"/_next/static/media/ic-message.43997f08.svg","height":15,"width":18,"blurWidth":0,"blurHeight":0};